import { z } from 'zod';

export const NonEmptyText = z.string().min(1);

export type NonEmptyText = z.infer<typeof NonEmptyText>;
